import { defineStore } from 'pinia';
import { ConversationMessageCreated } from '@/api/events';

export const useConversationStore = defineStore(
    'conversationStore',
    () => {
        const clientStore = useClientStore();
        const unreadMessageIds = ref<number[]>([]);

        useChannel(
            computed(() => (clientStore.context ? `users.${clientStore.context.user.id}` : undefined)),
            ConversationMessageCreated,
            data => {
                if (data && data.data.user_id !== clientStore.context?.user.id) {
                    unreadMessageIds.value.push(data.data.id);
                    if (unreadMessageIds.value.length > 99) {
                        unreadMessageIds.value = unreadMessageIds.value.slice(0, 99);
                    }
                }
            },
        );

        const markRead = (messageId: number | number[]) => {
            if (typeof messageId === 'number') {
                unreadMessageIds.value = unreadMessageIds.value.filter(id => id !== messageId);
            } else {
                const newArr = unreadMessageIds.value.filter(id => !messageId.includes(id));
                if (newArr.length === unreadMessageIds.value.length) {
                    return;
                }
                unreadMessageIds.value = newArr;
            }
        };

        const markAllRead = () => {
            if (unreadMessageIds.value.length === 0) {
                return;
            }
            unreadMessageIds.value = [];
        };

        return {
            unreadMessageIds,
            markRead,
            markAllRead,
        };
    },
    {
        persist: {
            storage: localStorage,
            // `paths` -> `pick`; see clientStore.ts.
            pick: ['unreadMessageIds'],
        },
    },
);
